export const SET_MODAL = 'SET_MODAL'
export const REMOVE_MODAL = 'REMOVE_MODAL'